//* Libraries imports
import { z } from "zod";

export const subprocessGeneratorSchema = z.object({
  _id: z.string().optional(),
  fieldId: z.string(),
  maxSubprocesses: z.number().optional(),
  minValues: z.number().optional(),
  maxValues: z.number().optional(),
  autoGenerate: z.boolean(),
  requireApproval: z.boolean(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
});
